/**
 * Theme-coloured app logo for TV listings fallback when channel/programme images fail.
 * Uses SVG_COLOUR_CONTROL approach: wrapper div sets --tv-fallback-logo-fill; global CSS applies it to path fill.
 */
import { useTheme } from '@/contexts/ThemeContext'
import logoSvg from '@/assets/sensorhub-logo.svg?raw'

const themeToFill: Record<string, string> = {
  light: '#000000',
  dark: '#FFFFFF',
  'yellow-black': '#FFFF00',
}

interface TvFallbackLogoProps {
  width: number
  height: number
  style?: React.CSSProperties
}

export default function TvFallbackLogo({ width, height, style = {} }: TvFallbackLogoProps) {
  const { theme } = useTheme()
  const fillColor = themeToFill[theme] ?? '#000000'

  return (
    <div
      className="tv-fallback-logo-fill"
      style={{
        ['--tv-fallback-logo-fill' as string]: fillColor,
        width,
        height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        ...style,
      } as React.CSSProperties}
      aria-hidden
    >
      <div
        dangerouslySetInnerHTML={{ __html: logoSvg }}
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  )
}
